export default "__VITE_ASSET__DxhURDvI__"